import { Helmet } from 'react-helmet-async';

interface ArticleStructuredDataProps {
  title: string;
  description: string;
  publishDate: string;
  modifiedDate?: string;
  imageUrl?: string;
}

export default function ArticleStructuredData({
  title,
  description,
  publishDate,
  modifiedDate = publishDate,
  imageUrl = 'https://rentfi.b-cdn.net/rentfi-logo.webp'
}: ArticleStructuredDataProps) {
  const articleData = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    "headline": title,
    "description": description,
    "datePublished": publishDate,
    "dateModified": modifiedDate,
    "author": {
      "@type": "Organization",
      "name": "RentFi Foundation"
    },
    "publisher": {
      "@type": "Organization",
      "name": "RentFi",
      "logo": {
        "@type": "ImageObject",
        "url": "https://rentfi.b-cdn.net/rentfi-logo.webp"
      }
    },
    "image": {
      "@type": "ImageObject",
      "url": imageUrl
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://rentfi.io/press"
    },
    "articleSection": "Press Releases",
    "keywords": "RentFi, blockchain real estate, property investment, RENT token, passive income",
    "inLanguage": "en-US"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(articleData)}
      </script>
    </Helmet>
  );
}